import { rest } from "msw";

import emotionalWellnessQuestionnaireResponses from "./data/questionnaireResponses/emotionalWellness.json";
import engagementPreferencesQuestionnaireResponses from "./data/questionnaireResponses/engagementPreferences.json";
import healthScreeningQuestionnaireResponses from "./data/questionnaireResponses/healthScreening.json";
import lifestyleQuestionnaireResponses from "./data/questionnaireResponses/lifestyle.json";
import emotionalWellnessQuestionnaire from "./data/questionnaires/emotionalWellness.json";
import engagementPreferencesQuestionnaire from "./data/questionnaires/engagementPreferences.json";
import healthScreeningQuestionnaire from "./data/questionnaires/healthScreening.json";
import lifestyleQuestionnaire from "./data/questionnaires/lifestyle.json";

export const AID_BOX_API_URL =
  process.env.REACT_APP_AIDBOX_URL || "https://app-dev.recurohealth.com";

export const handlers = [
  rest.get(`${AID_BOX_API_URL}/Questionnaire`, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        entry: [
          {
            resource: healthScreeningQuestionnaire,
          },
          {
            resource: emotionalWellnessQuestionnaire,
          },
          {
            resource: lifestyleQuestionnaire,
          },
          {
            resource: engagementPreferencesQuestionnaire,
          },
        ],
      })
    );
  }),
  rest.get(
    `${AID_BOX_API_URL}/Patient/$questionnaire-responses`,
    (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          questionnaireResponse: [
            {
              resource: healthScreeningQuestionnaireResponses,
            },
            {
              resource: emotionalWellnessQuestionnaireResponses,
            },
            {
              resource: lifestyleQuestionnaireResponses,
            },
            {
              resource: engagementPreferencesQuestionnaireResponses,
            },
          ],
        })
      );
    }
  ),
  rest.put(
    `${AID_BOX_API_URL}/Patient/$update-questionnaire-response`,
    async (req, res, ctx) => {
      const body = await req.json();
      return res(ctx.status(200), ctx.json(body));
    }
  ),
];
